import { SxProps } from '@mui/system';

import { theme } from 'theme';

export const root: SxProps = {
  position: 'relative',
};

export const bottomFade: SxProps = {
  position: 'absolute',
  bottom: 0,
  left: 0,
  height: '32px',
  width: '100%',
  zIndex: 2,
  pointerEvents: 'none',
  background:
    'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%)',
};

export const list: SxProps = {
  marginTop: '12px',
  display: 'flex',
  alignItems: 'flex-start',
  alignContent: 'flex-start',
  flexWrap: 'wrap',
  columnGap: '8px',
  rowGap: '12px',
  overflow: 'auto',
  height: '208px',
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',

  '&::-webkit-scrollbar': {
    display: 'none',
  },
};

export const notResultsText: SxProps = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  color: theme.palette.grey['A400'],
};
